import { ScenarioGroupView } from "@bitwarden/web-vault/app/models/view/scenario-group/scenario-group.view";
import { addYears } from "date-fns";

export function setAnchorDate(scenarioGroup: ScenarioGroupView, anchorDate?: Date) {
  anchorDate = anchorDate ?? new Date();
  // Reset time to start of the day so the generated transaction to start with is at the opening time
  anchorDate.setHours(0, 0, 0, 0);
  if (anchorDate) {
    scenarioGroup.anchorPoint = {
      date: anchorDate.toISOString(),
      time: anchorDate.toISOString().split("T")[0],
      timeZone: new Intl.DateTimeFormat().resolvedOptions().timeZone,
      reliableTimeSource: true,
    };
  }
}

export function setEndDate(scenarioGroup: ScenarioGroupView, endDate?: Date) {
  endDate = endDate ?? addYears(new Date(), 1);
  endDate.setHours(23, 59, 59);
  if (endDate) {
    scenarioGroup.endDate = {
      date: endDate.toISOString(),
      time: endDate.toISOString().split("T")[0],
      timeZone: new Intl.DateTimeFormat().resolvedOptions().timeZone,
      reliableTimeSource: true,
    };
  }
}
